import React from 'react';
import { link, NavLink} from 'react-router-dom';

const Navigation = () => {
    return (
        <div className="sidebar">
            <div className="id">

                <div className="idContent">
                    <img src="./media/billGates.jpg" alt="Photo de profil" />
                    <h3>Yann Cotard</h3>
                </div>
            </div>

            <div className="navigation">
                <ul>
                    <li>
                        <NavLink 
                         to="/" 
                              style={({isActive}) => {
                                  return isActive ? {color:"#4fedd2"} : {color:"#36d0ea"}
                              }}>
                        
                            <i className='fas fa-home'></i>
                            <span>Accueil</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                         to="/knowledges"
                         style={({isActive}) => {
                            return isActive ? {color:"#4fedd2"} : {color:"#36d0ea"}
                        }} >
                            <i className='fas fa-mountain'></i>
                            <span>Compétences</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink 
                         to="/portfolio"
                         style={({isActive}) => {
                            return isActive ? {color:"#4fedd2"} : {color:"#36d0ea"}
                        }} >
                            <i className='fas fa-images'></i>
                            <span>Portfolio</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                         to="/contact"
                         style={({isActive}) => {
                            return isActive ? {color:"#4fedd2"} : {color:"#36d0ea"}
                        }} >
                            <i className='fas fa-address-book'></i>
                            <span>Contact</span>
                        </NavLink>
                    </li>
                </ul>
            </div>

            <div className="socialNetwork">
                <ul>
                    <li>
                        <a href="https://www.linkedin.com/in/yann-cotard?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BtWq2WlW2QKavN%2B5RyMmTpQ%3D%3D" target="_blank" rel="noopener noreferrer"><i className='fab fa-linkedin'></i></a>
                    </li>
                    <li>
                        <a href="https://github.com/Yann6666" target="_blank" rel="noopener noreferrer"><i className='fab fa-github'></i></a>
                    </li>
                    <li>
                        <a href="https://codepen.io/your-work" target="_blank" rel="noopener noreferrer"><i className='fab fa-codepen'></i></a>
                    </li>
                  
                </ul>
                <div className="signature">
                    <p>Yann Cotard - 2021</p>
                </div>
            </div> 
        </div>

    );
};

export default Navigation;